var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 379 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M90.75 384l22.75-22.75-58.75-58.75-22.75 22.75v26.75h32v32h26.75zM221.5 152c0-3.25-2.25-5.5-5.5-5.5-1.5 0-3 0.5-4.25 1.75l-135.5 135.5c-1.25 1.25-1.75 2.75-1.75 4.25 0 3.25 2.25 5.5 5.5 5.5 1.5 0 3-0.5 4.25-1.75l135.5-135.5c1.25-1.25 1.75-2.75 1.75-4.25zM208 104l104 104-208 208h-104v-104zM378.75 128c0 8.5-3.5 16.75-9.25 22.5l-41.5 41.5-104-104 41.5-41.25c5.75-6 14-9.5 22.5-9.5s16.75 3.5 22.75 9.5l58.75 58.5c5.75 6 9.25 14.25 9.25 22.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.56156bc6ee2a3c39c4967f75e6305998.svg";
export { ForwardRef as ReactComponent };